<ui-modal modalTitle="Select Task" size="xl" [scrollable]="true" [fullHeight]="true" [embed]="embed" [header]="mode !== 'book'">

	<div class="d-flex align-items-center flex-wrap mr-3" ui-modal-header *ngIf="mode !== 'book'">
		<ng-container *ngIf="filterList">
			<div class="flex-weight-1"></div>
			<div *ngIf="isAnyFilterActive()" class="icon-clear-filters px-2 mr-3 selectable" (click)="clearAllFilters()">
				<i class="wq wq-refresh "></i>
			</div>
			<div *ngIf="projectList.length && projectId === null" class="mr-3 w-7r">
				<ui-checkbox-dropdown dropdownName="Project" [items]="projectList" [selectedItems]="service.projectFilter" [selectProp]="'id'" (selectionChange)="handleSelectionChange($event, 'project')"></ui-checkbox-dropdown>
			</div>
			<div *ngIf="systemList.length" class="mr-3 w-7r">
				<ui-checkbox-dropdown dropdownName="System" [items]="systemList" [selectedItems]="service.systemFilter" [selectProp]="'id'" (selectionChange)="handleSelectionChange($event, 'system')"></ui-checkbox-dropdown>
			</div>
			<div *ngIf="areaList.length" class="mr-3 w-7r">
				<ui-checkbox-dropdown dropdownName="Area" [items]="areaList" [selectedItems]="service.areaFilter" [selectProp]="'id'" (selectionChange)="handleSelectionChange($event, 'area')"></ui-checkbox-dropdown>
			</div>
			<div *ngIf="labourTypeList.length" class="mr-3 w-7r">
				<ui-checkbox-dropdown dropdownName="Labour" [items]="labourTypeList" [selectedItems]="service.labourTypeFilter" [selectProp]="'id'" (selectionChange)="handleSelectionChange($event, 'labourType')"></ui-checkbox-dropdown>
			</div>
			<!-- <div *ngIf="teamList.length" class="mr-3 w-7r">
				<ui-checkbox-dropdown dropdownName="Team" [items]="teamList" [selectedItems]="service.teamFilter" [selectProp]="'id'" (selectionChange)="handleSelectionChange($event, 'team')"></ui-checkbox-dropdown>
			</div> -->
			<div *ngIf="userList.length" class="mr-3 w-7r">
				<ui-checkbox-dropdown dropdownName="User" [items]="userList" [selectedItems]="service.userFilter" [selectProp]="'id'" (selectionChange)="handleSelectionChange($event, 'user')"></ui-checkbox-dropdown>
			</div>
			<div *ngIf="phaseList.length" class="mr-3 w-7r">
				<ui-checkbox-dropdown dropdownName="Phase" [items]="phaseList" [selectedItems]="service.phaseFilter" [selectProp]="'id'" (selectionChange)="handleSelectionChange($event, 'phase')"></ui-checkbox-dropdown>
			</div>
			<div *ngIf="tasks">
				<div class="input-group">
					<div class="input-group-prepend">
						<span class="input-group-text"><i class="wq wq-search"></i></span>
					</div>
					<input type="search" class="form-control" placeholder="Search" [(ngModel)]="taskSearchList" (ngModelChange)="refreshList(500)" autocomplete="chrome-off" spellcheck="false" appDesktopFocus>
				</div>
			</div>
		</ng-container>
	</div>

	<div class="d-flex mt-n4 sticky-tabs" *ngIf="mode !== 'book'">
		<div *ngFor="let s of stageList" class="px-3 py-4 flex-weight-1 selectable hoverable border-bottom d-flex align-items-center border-{{service.stageColor(s, service.stageFilter === s, 'lightgrey')}}" [ngClass]="{ 'border-4': service.stageFilter === s }" (click)="selectStageFilter(s)">
			<span class="text-uppercase text-small text-bold mr-2" [ngClass]="{ 'text-secondary': service.stageFilter !== s }">{{service.stageDescription(s)}}</span>
			<span *ngIf="tasks" class="badge badge-{{service.stageColor(s, service.stageFilter === s)}}">{{stageTotal(s)}}</span>
		</div>
	</div>

	<table *ngIf="tasks" class="table table-hover" [ngClass]="{ 'mt-n4': mode === 'book' }">
		<thead>
			<tr [ngClass]="{ 'sticky': mode !== 'book' }">
				<th class="selectable text-center" [ngClass]="{ 'sticky': mode !== 'book' }" (click)="sortBy('priority')">Priority <i class="{{sortClass('priority')}}"></i></th>
				<th class="selectable" [ngClass]="{ 'sticky': mode !== 'book' }" (click)="sortBy('id')">#<i class="{{sortClass('id')}}"></i></th>
				<th class="selectable" [ngClass]="{ 'sticky': mode !== 'book' }" (click)="sortBy('name')" style="max-width: 13rem;">Name <i class="{{sortClass('name')}}"></i></th>
				<th class="selectable text-center" [ngClass]="{ 'sticky': mode !== 'book' }" (click)="sortBy('created_datetime')">Created On/By <i class="{{sortClass('created_datetime')}}"></i></th>
				<th class="selectable" [ngClass]="{ 'sticky': mode !== 'book' }" (click)="sortBy('work_order_no')">Job / Assigned To <i class="{{sortClass('work_order_no')}}"></i></th>
				<th class="selectable text-right" [ngClass]="{ 'sticky': mode !== 'book' }" (click)="sortBy('last_activity')">Last Activity <i class="{{sortClass('last_activity')}}"></i></th>
				<th class="text-center shrink px-0" [ngClass]="{ 'sticky': mode !== 'book' }">
					<div style="width: 1px; height: 16px; background-color: grey; margin-left: 9px; margin-right: 9px;">&nbsp;</div>
				</th>
				<th class="selectable text-left" [ngClass]="{ 'sticky': mode !== 'book' }" (click)="sortBy('next_allocation')">Next Booking <i class="{{sortClass('next_allocation')}}"></i></th>
				<th [ngClass]="{ 'sticky': mode !== 'book' }">Worked / Budgeted Time</th>
				<th class="text-center" [ngClass]="{ 'sticky': mode !== 'book' }" style="max-width: 10rem;">Progress</th>
				<th class="selectable" [ngClass]="{ 'sticky': mode !== 'book' }" (click)="sortBy('billable')">Billing Status <i class="{{sortClass('billable')}}"></i></th>
			</tr>
		</thead>
		<tbody>
			<tr *ngFor="let item of tasks.list.result" class="selectable" [ngClass]="{'table-warning': item.stage === 'follow_up' || item.sub_task_follow_count > 0}" (click)="selectItem(item)">
				<td class="text-center">
					<ui-task-priority [priority]="item.priority"></ui-task-priority>
				</td>
				<td class="shrink">{{item.id}}</td>
				<td style="max-width: 13rem;">
					<div><span class="text-lines lines-1 text-bold" uiEllipsisTooltip>{{item.name}}</span></div>
					<div class="mt-1" *ngIf="projectId === null">
						{{item.customer_name}}
						<ng-container *ngIf="item.project">
							<span class="text-secondary">/</span>
							<span target="_blank" class="text-info text-bold" ngbTooltip="Go to the Project" (click)="goToProject(item.project_id); $event.stopPropagation()">{{item.project}}</span>
						</ng-container>
					</div>
				</td>
				<td class="text-center">
					<div class="d-flex align-items-center justify-content-center">
						<i *ngIf="!item.created_from_snagg" class="wq wq-device-desktop mr-1 mt-1" ngbTooltip="Created On PC"></i>
						<i *ngIf="item.created_from_snagg" class="wq wq-device-mobile mr-1 mt-1" ngbTooltip="Created On Mobile"></i>
						{{ item.created_user_name }}
					</div>
					<div class="text-secondary mt-1">{{item.created_datetime | mySQLDateToISO | localizedDate:'shortDate'}}</div>
				</td>
				<td>
					<div *ngIf="item.work_order_no" [ngbTooltip]="item.work_order_name">Job {{item.work_order_no}}</div>
					<div class="d-flex align-items-center" *ngIf="item.users?.length" [ngbTooltip]="allocationTooltip">
						<ng-container *ngFor="let user of item.users; let i = index">
							<ui-user-image *ngIf="i < 3" [email]="user.email" style="margin-left: -5px;" [title]="user.title"></ui-user-image>
						</ng-container>
						<div *ngIf="item.users.length > 3" class="extra-count">
							<span style="border-radius: 50%; color: #fff; padding: 0.45rem; margin-left: -5px;" class="bg-secondary">+{{ item.users.length - 3 }}</span>
						</div>
					</div>
				</td>
				<ng-template #allocationTooltip>
					<table class="mb-2" *ngFor="let allocation of item.users">
						<tr>
							<td class="text-left text-bold">{{allocation.title}}</td>
							<td></td>
							<td></td>
						</tr>
						<tr>
							<td class="text-left">Last worked</td>
							<td> - </td>
							<td class="text-center text-bold">{{allocation.last_clocked_in_datetime | mySQLDateToISO | localizedDate: 'shortDate'}}</td>
						</tr>
						<tr>
							<td class="text-left">Next Booking</td>
							<td> - </td>
							<td class="text-center text-bold">{{allocation.next_allocation_start_date | mySQLDateToISO | localizedDate: 'shortDate'}}</td>
						</tr>
					</table>
				</ng-template>
				<td class="text-right pr-0">
					<ng-container *ngIf="item.last_clocked_in_datetime; else noActivity">
						{{item.last_day_of_week}}
						{{item.last_clocked_in_datetime | mySQLDateToISO | localizedDate: 'shortDate'}}<br>
						<small class="text-secondary">{{item.activity_text}}</small>
					</ng-container>
					<ng-template #noActivity>
						<div class="text-muted mt-2 text-center">-</div>
					</ng-template>
				</td>
				<td class="text-center shrink px-0">
					<div style="width: 1px; height: 30px; background-color: grey; margin-left: 9px; margin-right: 9px;">&nbsp;</div>
				</td>
				<td class="text-left pl-0">
					<div *ngIf="item.next_allocation_start_date; else noAllocation" class="d-flex align-items-center">
						<div>
							{{item.next_day_of_week}} {{item.next_allocation_start_date | mySQLDateToISO | localizedDate:'shortDate'}}<br>
							<small class="text-secondary">{{item.next_allocation_text}}</small>
						</div>
					</div>
					<ng-template #noAllocation>
						<div class="text-muted mt-2 text-center">-</div>
					</ng-template>
				</td>
				<td class="text-center" style="max-width: 10rem;">
					<ui-task-progress-bar [item]="item" [simplifiedMode]="true"></ui-task-progress-bar>
				</td>
				<td>
					<div *ngIf="item.sub_task_count" class="d-flex align-items-center no-wrap justify-content-center">
						<div class="mr-2" style="font-size: 0.8rem;" [ngClass]="{ 'text-success': item.completed_sub_task_count === item.sub_task_count }">
							{{ item.completed_sub_task_count || 0 }}/{{ item.sub_task_count }}
							Subtasks Completed
						</div>
					</div>
					<div *ngIf="!item.sub_task_count" class="d-flex align-items-center justify-content-center">
						<div class="mr-2" style="font-size: 0.8rem;" [ngClass]="{ 'text-success': item.stage === 'completed' }">
							{{item.stage === 'completed' ? '1' : '0' }}/1 Task Completed
						</div>
					</div>
					<div class="d-flex align-items-center justify-content-center mt-1">
						<div class="mr-3" [ngClass]="{ 'text-primary': item.notes?.length, 'text-secondary': !item.notes?.length }">
							<div><i class="wq wq-notes mr-2" [ngbTooltip]="item.notes?.length ?'Notes' : null"></i><span class="text-small">{{item.notes?.length ? item.notes?.length : '0'}}</span></div>
						</div>
						<div class="mr-3">
							<div [ngClass]="{ 'text-warning': item.stock_variation_count, 'text-secondary': !item.stock_variation_count }">
								<i class="wq wq-warning mr-1" [ngClass]="{'text-warning': item.stock_variation_count, 'text-secondary': !item.stock_variation_count}" [ngbTooltip]="item.stock_variation_count ? 'Stock Variation' : null"></i> {{item.stock_variation_count || 0}}
							</div>
						</div>
						<div>
							<div>
								<i class="wq wq-dependency-photo" [ngbTooltip]="item.dependencies?.length ? 'Dependencies' : null" [ngClass]="{ 'text-primary': getCompletedDependencies(item.dependencies) > 0, 'text-secondary': getCompletedDependencies(item.dependencies) === 0 }"></i>
								<span class="text-small text-secondary">
									<ng-container *ngIf="item.dependencies?.length">
										<span [ngClass]="{'text-primary': getCompletedDependencies(item.dependencies) > 0}">
											{{ getCompletedDependencies(item.dependencies) }}
										</span>
										<span [ngClass]="{ 'text-secondary': item.dependencies?.length === 0, 'text-primary': getCompletedDependencies(item.dependencies) === item.dependencies?.length && item.dependencies?.length > 0 }">/</span>
									</ng-container>
									<span [ngClass]="{ 'text-secondary': item.dependencies?.length === 0, 'text-primary': getCompletedDependencies(item.dependencies) === item.dependencies?.length && item.dependencies?.length > 0 }">
										{{ item.dependencies?.length || 0 }}
									</span>
								</span>
							</div>
						</div>
					</div>
				</td>
				<td>
					<div class="badge badge-{{service.stageColor(item.stage)}}">{{service.stageDescription(item.stage)}}</div>
					<span *ngIf="item.stage === 'completed'" class="text-small text-success text-bold ml-1">{{item.completed_datetime | mySQLDateToISO | localizedDate:'shortDate'}}</span>
					<br>
					<div *ngIf="item.billable" class="badge badge-info mr-2 mt-1">Billable</div>
					<div *ngIf="!item.billable" class="badge badge-secondary mr-2 mt-1">Not Billable</div>
				</td>
			</tr>
			<tr *ngIf="!pagination.count">
				<td colspan="10" class="text-secondary">No tasks found.</td>
			</tr>
		</tbody>
	</table>

	<div class="flex-weight-1" ui-modal-footer>
		<app-pagination [pagination]="pagination" (navigate)="refreshList(100)"></app-pagination>
	</div>
	<button *ngIf="!embed" class="btn btn-secondary" (click)="modal.close()" ui-modal-footer>Cancel</button>
</ui-modal>
<app-modal-task-details *ngIf="mode && mode === 'book'" (close)="taskDetailsModalClosed($event)"></app-modal-task-details>
